export const PASSWORD_REQUIREMENT_MESSAGE = 'Password must be at least 8 characters and include one uppercase letter and one number.';
export const DUPLICATE_EMAIL_SIGNUP_MESSAGE = 'It looks like you already have an account. Please sign in or reset your password.';
export function isPasswordStrong(password) {
    return password.length >= 8 && /[A-Z]/.test(password) && /\d/.test(password);
}
